export default __webpack_public_path__ + "b58f6c70096b70d67b3157032e73c4ff.png";